// src/components/MainFooter.js
import React from 'react';
import { Link } from 'react-router-dom';

function MainFooter() {
  return (
    <footer className="relative bg-background-secondary border-t-2 border-border overflow-hidden">
      {/* ... decorative elements ... */}
      <div className="absolute inset-0 opacity-10">
        { /* ...bubbles... */ }
      </div>

      <div className="relative z-10 max-w-7xl mx-auto py-3 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
          <p className="text-sm text-content-secondary font-medium drop-shadow-sm">
            &copy; {new Date().getFullYear()} <span className="font-bold text-content-primary">Kikikata</span>. All rights reserved.
          </p>

          <div className="flex space-x-6">
            <Link
              to="/privacy-policy"
              className="group relative text-sm text-content-secondary hover:text-primary font-medium transition-colors duration-200 drop-shadow-sm"
            >
              <span className="relative z-10">Privacy</span>
              {/* REMOVED backdrop-blur-sm from this div */}
              <div className="absolute inset-0 -m-2 rounded-lg  opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
            </Link>
            <Link
              to="/terms-of-service"
              className="group relative text-sm text-content-secondary hover:text-primary font-medium transition-colors duration-200 drop-shadow-sm"
            >
              <span className="relative z-10">Terms</span>
              {/* REMOVED backdrop-blur-sm from this div */}
              <div className="absolute inset-0 -m-2 rounded-lg bg-gradient-to-r from-secondary/20 to-accent/20 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
            </Link>
            <Link
              to="/cookie-policy"
              className="group relative text-sm text-content-secondary hover:text-primary font-medium transition-colors duration-200 drop-shadow-sm"
            >
              <span className="relative z-10">Cookies</span>
              {/* REMOVED backdrop-blur-sm from this div */}
              <div className="absolute inset-0 -m-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default MainFooter;